import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleCategory from '../../components/Category';

import iconImg1 from '../../assets/img/service/icon-1-1.png';
import iconImg2 from '../../assets/img/service/icon-1-2.png';
import iconImg3 from '../../assets/img/service/icon-1-3.png';
import iconImg4 from '../../assets/img/service/icon-1-4.png';
import iconImg5 from '../../assets/img/service/icon-1-5.png';
import iconImg6 from '../../assets/img/service/icon-1-6.png';

const Category = () => {
  return (
    <div id="it-category" className="it-categori-area pt-120 pb-100">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <SectionTitle
              itemClass="it-categori-title-box text-center mb-65"
              subTitleClass="it-section-subtitle"
              subTitle="Categories"
              titleClass="it-section-title"
              title="Top Categories"
            />
          </div>
        </div>
        <div className="row gx-20 justify-content-center row-cols-xl-6 row-cols-lg-4 row-cols-md-3 row-cols-sm-2">
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleCategory
              iconImage={iconImg1}
              title="Medicine"
              itemCount="5k+ Items"
            />
          </div>
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".4s"
          >
            <SingleCategory
              iconImage={iconImg2}
              title="Sanitizer"
              itemCount="7k+ Items"
            />
          </div>
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleCategory
              iconImage={iconImg3}
              title="Thermometer"
              itemCount="5k+ Items"
            />
          </div>
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".6s"
          >
            <SingleCategory
              iconImage={iconImg6}
              title="Gloves"
              itemCount="9k+ Items"
            />
          </div>
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleCategory
              iconImage={iconImg4}
              title="Microscope"
              itemCount="10k+ Items"
            />
          </div>
          <div
            className="col mb-20 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".8s"
          >
            <SingleCategory
              iconImage={iconImg5}
              title="Accessories"
              itemCount="5k+ Items"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Category;
